// extracted by mini-css-extract-plugin
export default {"darkpage":"NoShow_darkpage__ouYFN","darkpage_logo":"NoShow_darkpage_logo__Ub6wD","darkpage_card":"NoShow_darkpage_card__L7x1o","darkpage_link":"NoShow_darkpage_link__CENlt"};